import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportAbsencesPDF = ({ data ,logo}) => {
  const { t } = useTranslation();
const formatPrettyDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
    {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
           {t("absence.heading")}
        </Text>

        {data.map((item, idx) => (
          <View key={idx} style={styles.recordGroup}>
            
            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.worker")}:</Text>
              <Text style={styles.value}>{item.worker?.name}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.department")}:</Text>
              <Text style={styles.value}>{item.worker?.department}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.type")}:</Text>
              <Text style={styles.value}>{item.absence?.type?.name}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.start_date")}:</Text>
              <Text style={styles.value}> {formatPrettyDate(item.absence?.startDate)}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.end_date")}:</Text>
              <Text style={styles.value}>  {formatPrettyDate(item.absence?.endDate)}
</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.source")}:</Text>
              <Text style={styles.value}>{item.absence?.source}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("absence.comments")}:</Text>
              <Text style={styles.value}>{item.absence?.comment}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportAbsencesPDF;
